import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import moment from 'moment'
import fileSize from 'filesize'

import FileDisplay from 'components/file/file-display'

import isEqual from 'react-fast-compare'

import { 
    isMobile,
    getFileExtension,
    showWhatChanged
} from 'utils'

class ProjectFile extends Component {
    ref = null

    clickFile = _ => {
        if(!this.props.isActive){
            this.props.history.push(this.props.matchPath+'/'+this.props.file.id)
        }else{
            this.props.history.push(this.props.matchPath)
        }
    }

    shouldComponentUpdate = nextProps => {
        const arePropsEqual = isEqual(this.props, nextProps)

        return !arePropsEqual
    }

    render(){
        const { 
            file,
            lastUser,
            blockFileTransition,
            index,
            normalisedIndex,
            isActive,
            openPreviewModal,
            shouldRender,
            isLoading
        } = this.props

        if(!file.latestVersion){
            return null
        }

        let uploadMeta = '' 

        const createdMoment = moment(file.latestVersion.created_at)

        if(createdMoment.isSame(moment(), 'day')){
            uploadMeta = `${moment(file.latestVersion.created_at).format('[Today at] h:mm a')}`
        }else{
            uploadMeta = `${moment(file.latestVersion.created_at).format('D MMM [at] h:mm a')}`
        }

        const style = {
            transitionDelay: (index/15)+'s'
        }

        if(blockFileTransition){
            style.transition = '0s'
        }

        // don't destructure this
        let className = this.props.className+' list-item'

        if(blockFileTransition){
            className += ' block-transition'
        }

        if(isMobile()){
            className += ' no-hover'
        }

        if(isLoading){
            className += ' loading'
        }

        return(
            <li 
                ref={ref => this.ref = ref} 
                style={style} 
                className={className}
            >
                <button onClick={_ => {
                    openPreviewModal(normalisedIndex)
                }} className={isActive ? 'active' : null}>
                    <div className="file-grid-top">
                        { shouldRender &&
                            <FileDisplay animateOnRender={true} file={file.latestVersion} />
                        }
                    </div>
                    <div className="file-grid-meta">
                        <span>
                            <span>
                                { file.name }
                            </span>
                            <div className="list-info">
                                <span>
                                    <span>
                                        { uploadMeta }
                                    </span> 
                                </span>
                                <span>
                                    <span>
                                        { fileSize(file.latestVersion.size) }
                                    </span>
                                </span>
                                <span>
                                    { lastUser ? `${lastUser.first_name} ${lastUser.last_name}` : '(A deleted user)' }
                                </span>
                                <span>
                                    { getFileExtension(file.latestVersion.filename) }
                                </span>
                            </div>
                        </span>
                    </div>
                </button>
            </li>
        )
    }
}

export default ProjectFile



// WEBPACK FOOTER //
// ./src/sections/projects/project/project-files/project-file.jsx